import { Component, Input, OnInit } from '@angular/core';

import { AddressService } from 'src/app/services/api/address/address.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { Day } from 'src/app/models/day';
import { FlowPage } from '../../../flow-director';
import { ModalService } from 'src/app/services/modal/modal.service';
import { OrderService } from 'src/app/services/api/order/order.service';
import { Service } from 'src/app/models/service';
import { TimeSlot } from 'src/app/models/time-slot';
import { UserAddress } from 'src/app/models/user-address';
import moment from 'moment-timezone';

export interface DayTimeSelectorPageProps {
  service: Service;
  userAddress: UserAddress;
}

export interface DayTimeSelectorPageForm {
  slot?: TimeSlot;
}

@Component({
  selector: 'ysh-day-time-selector',
  templateUrl: './day-time-selector.page.html',
  styleUrls: ['./day-time-selector.page.scss'],
})
export class DayTimeSelectorPage implements OnInit, FlowPage {
  @Input() onComplete: (slot: TimeSlot) => void;
  @Input() onDismiss: () => void;
  @Input() preventBackNavigation?: boolean = false;
  @Input() props: DayTimeSelectorPageProps;

  loading = true;
  form: DayTimeSelectorPageForm = {};
  days: Day[] = [];
  selectedDay?: Day;

  constructor(
    private addressService: AddressService,
    private orderService: OrderService,
    private analytics: AnalyticsService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.analytics.trackView('DayTimeSelectorPage');
    this.loadTimeSlots();
  }

  private sortDays(days: Day[]) {
    return days.sort((a, b) => a.nextDate.getTime() - b.nextDate.getTime());
  }

  // Actions

  didTapOnDay(day) {
    this.selectedDay = day;
    this.setDefaultTime();
  }

  didTapOnSlot(slot: TimeSlot) {
    this.form.slot = slot;
  }

  didTapDismiss() {
    this.modalService.dismissModal();
  }

  didTapBack() {
    this.onDismiss?.();
  }

  didTapDone() {
    this.onComplete(this.form.slot!);
  }

  // Data

  private loadTimeSlots() {
    return this.addressService
      .getTimeSlots(this.props.userAddress, null, null, this.props.service)
      .subscribe((slots) => {
        const days = this.props.userAddress.getDays(24, this.props.service, slots) || [];
        this.days = this.sortDays(days);
        this.setDefaultDay();
        this.setDefaultTime();
        this.loading = false;
      });
  }

  private setDefaultDay() {
    this.selectedDay = this.days.find((day) => day.slots.find((slot) => slot.available));
  }

  private setDefaultTime() {
    this.form.slot = this.selectedDay?.slots.find((slot) => slot.available);
  }

  // Helpers

  isDaySelected(someDay: Day) {
    return this.selectedDay?.dayIndex === someDay.dayIndex;
  }

  isDayServiced(day: Day) {
    return day.slots && day.slots.length > 0;
  }
}
